import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";
const style = () => {
    const { colorTextMedium, space4, space6 } = theme();
    return StyleSheet.create({
        descriptionText: {
            marginBottom: space4,
        },
        modal: {
            paddingHorizontal: space6,
        },
        modalGap: {
            marginTop: space6,
        },
        text: {
            color: colorTextMedium,
        },
    });
};
export { style };
